import script from "./LiveSportOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSportOverview.vue?vue&type=script&setup=true&lang=js"

import "./LiveSportOverview.vue?vue&type=style&index=0&id=646dd319&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-646dd319"]])

export default __exports__